{
  "version": 1,
  "asset_id": "70c7dd0e-d049-4ef9-9cb3-318d3d0b678e",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/70c7dd0e-d049-4ef9-9cb3-318d3d0b678e/danny-intro.mp4",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/70c7dd0e-d049-4ef9-9cb3-318d3d0b678e/danny-intro.mp4",
  "original_filename": "danny-intro.mp4",
  "size": 4179406,
  "content_type": "video/mp4",
  "created_at": "2026-06-16T09:45:11Z"
}
